<template>
  <div
    v-if="mapperCountryToCards[currencyCode].length"
    class="am-card-list"
  >
    <img
      v-for="flagName in mapperCountryToCards[currencyCode]"
      :key="flagName"
      class="am-card-list__flag-card"
      :src="require(`@/assets/images/${flagName}.svg`)"
      data-test="am-card-list:flag-card"
    />
  </div>
</template>
<script>
export default {
  name: 'AmCardList',
  props: {
    mapperCountryToCards: {
      type: Object,
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.am-card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
</style>
